import React from 'react';

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  return (
    <div className="error-wrapper">
        <strong>Fel:</strong> {message}
    </div>
  );
};

export default ErrorMessage;
